import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, paramCheck } from '../utils';

export interface GotoBrowserOption extends Partial<GeneralInvokeOption> {
  openUrl: string;
  invalidParamObj?: '';
}

// 跳转到第三方app
export function gotoBrowser(option: GotoBrowserOption) {
  if (!option.openUrl) {
    return logErrorAndRunFail(
      APINames.Native.GO_TO_BROWSER,
      option,
      'parameter error:parameter.openUrl should be String instead of Undefined.'
    );
  }
  if (
    paramCheck(APINames.Native.GO_TO_BROWSER, option, {
      openUrl: ''
    })
  ) {
    return MacleJSBridge.beforeInvoke(APINames.Native.GO_TO_BROWSER, option);
  }
  return option.invalidParamObj;
}
